import Layout from './Layout';
import Layout2020 from './Layout2020';
import LayoutHero from './LayoutHero';
import Ids from '../config/ids';
import { isHeroBrandEnabled } from '../utils/heroBrandUtils';

const assets = {
  textOnlyLogo: require('../images/logo.png'),
  logo: require('../images/logo2.png'),
  monetra_logo: require('../images/blitz_logo2.png'),
  hero_logo: require('../images/hero_logo.png'),
  hero_logo_white: require('../images/hero_logo_white.png'),
  hero_logo_horizontal: require('../images/hero_logo_horizontal.png'),
  hero_logo_horizontal_white: require('../images/hero_logo_horizontal_white.png'),
  poweredByLogo: require('../images/powered_by_tulka.png'),
  background_login: require('../images/bg_login.jpg'),
};

const fontLuona = 'Rubik';

const fontNormal = 'GothamRounded-Book';
const fontMedium = 'GothamRounded-Medium';
const fontBold = 'GothamRounded-Bold';

// Hero Brand Fonts
const heroFontNormal = 'Arial, Helvetica, sans-serif'; // Fallback to Arial as per brand guidelines
const heroFontMedium = 'Arial, Helvetica, sans-serif';
const heroFontBold = 'Arial, Helvetica, sans-serif';

const blitzFontNormal = 'HaboroSlab-NorMed';
const blitzFontMedium = 'HaboroSlab-NorMed';
const blitzFontBold = 'HaboroSlab-NorMed';

const blitzYellow = '#F39200';
const blitzRed = '#B51F2A';
const blitzLightRed = '#C52F3A';
const blitzGrey = '#C2C2C2';
const blitzDarkGrey = '#575656';

let brand = 'tulka';

export async function getNativeColors(user) {
  return getColors(user);
}

export function getAppVariant() {
  return brand;
}

export default function getColors(user) {
  let contractPartnerId = Ids.contractPartners.tulka;

  let contractPartnerName = 'Túlka';
  let businessTypeName = 'B2B';

  if (user) {
    if (user.userGroup) {
      if (user.userGroup.contractPartner) {
        contractPartnerId = user.userGroup.contractPartner.id;
        contractPartnerName = user.userGroup.contractPartner.name;
      }
      if (user.userGroup.businessType) {
        businessTypeName = user.userGroup.businessType.name;
      }
    } else if (user.contractPartners && user.contractPartners.length > 0) {
      contractPartnerId = user.contractPartners[0].id;
      contractPartnerName = user.contractPartners[0].name;
    }

    if (user.businessTypes && user.businessTypes.length > 0) {
      businessTypeName = user.businessTypes[0].name;
    }
  }

  let colors = {
    brand: 'tulka',
    businessType: businessTypeName,
    partner: contractPartnerName,
    // Tulka brand colors
    twilight: Layout.color.twilight,
    beach: Layout.color.beach,
    coral: Layout.color.coral,
    // Color variants with opacity (for borders, placeholders, hover states)
    borderColorLight: Layout.color.twilightBorderLight,
    borderColor: Layout.color.twilightBorder,
    borderColorMedium: Layout.color.twilightBorderMedium,
    placeholderColor: Layout.color.twilightPlaceholder,
    secondaryColor: Layout.color.twilightSecondary,
    hoverColor: Layout.color.twilightHover,
    showPhoneNumber: true,
    hideRealSubscriberName: false,
    autoSelectUILanguage: false,
    showInvoiceRef: true,
    feedbackSliders: false,
    showMessageIfNoLanguageSelected: true,
    showMessageIfNoInterpreters: false,
    hideFreeTextFeedback: true,
    noLanguageSelection: false,
    showKeepDisplayOn: true,
    phoneNumberUsername: true,
    statusBarStyle: 'light-content',
    logo: assets.logo,
    pickerTextColor: Layout.color.twilight,
    pickerSelectedTextColor: Layout.color.beach,
    popupTextColor: Layout.color.beach,
    notificationTextColor: Layout.color.semiBlack,
    notificationBoldTextColor: Layout.color.twilight,
    buttonColor: Layout.color.beach,
    buttonTextColor: Layout.color.white,
    buttonDisabledColor: Layout.color.gray,
    buttonDisabledTextColor: Layout.color.lightGray,
    lastButtonColor: Layout.color.glass,
    lastButtonTextColor: Layout.color.darkBeach,
    textFont: fontNormal,
    fontLuona: fontLuona,
    buttonFont: fontBold,
    primaryButtonFont2020: fontMedium,
    secondaryButtonFont2020: fontNormal,
    titleFont: fontBold,
    infoFont: fontMedium,
    backgroundColor: Layout.color.white,
    textColor: Layout.color.white,
    durationColor: Layout.color.beach,
    openRequestsColor: 'transparent',
    logoStyle: { tintColor: Layout.color.white },
    loginLogoStyle: { opacity: 0.8 },
    logoWidth: 0.33,
    poweredByLogoStyle: { height: 0 },
    logoPadding: 0,
    logoBottomMargin: 20,
    menuColor: Layout.color.white,
    containerColor: Layout.color.twilight,
    selectedColor: 'rgba(0, 0, 0, 0.2)',
    selectedTextColor: 'rgba(255, 255, 255, 0.5)',
    placeholderTextColor: Layout.color.sky,
    textAreaBackground: Layout.color.twilight,
    textAreaBorderColor: Layout.color.white,
    textAreaTextColor: Layout.color.white,
    textInputTextColor: Layout.color.twilight,
    textInputBackgroundColor: Layout.color.white,
    textAreaFont: fontNormal,
    textInputFont: fontBold,

    backgroundColorAi: '#e4e4ff80',
    webDarkBlue: '#151529',
    tulkaMainColor: '#3A385B',
    iconAccentColor: Layout.color.twilight,
    webBackground: '#F6F9FC',
    webGray: '#75706f',
    webMediumGray: '#929292',
    webOverlay: 'rgba(21, 21, 41, 0.9)',
    webLightGray: '#F5F8FB',
    webSuccessColor: '#36b37e',
    webDefaultInputBorderColor: '#d8d8dc',
    webTextColor: Layout.color.white,
    webMyTulkaGrayColor: '#f6f6f8',
    webMyTulkaErrorBackground: '#feebeb',
    webMyTulkaErrorText: '#d18e8a',
    webDeviderColor: '#dee1e6',

    feedbackGrayColor: Layout.color.semiGray,
    feedbackBgColor: Layout.color.twilight,
    feedbackSwitchColor: Layout.color.twilight,

    popupTextInputBorderColor: Layout.color.white,
    popupTextInputTextColor: Layout.color.semiBlack,
    popupTextInputBackgroundColor: Layout.color.white,
    popupPlaceholderTextColor: Layout.color.lightGray,
    popupTextInputFont: fontNormal,

    stars: Layout.color.white,
    showContinueButton: true,
    contactMeNow: true,
    poweredByLogo: assets.poweredByLogo,
    error: Layout.color.coral,
    warn: Layout.color.beach,
    success: Layout.color.twilight,
    successTextColor: Layout.color.white,
    acceptColor: Layout.color.beach,
    acceptTextColor: Layout.color.white,
    cancelColor: Layout.color.coral,
    cancelTextColor: Layout.color.white,
    errorColor: Layout.color.coral,
    menuItemCountColor: Layout.color.coral,
    background_login: assets.background_login,
    video: assets.video,
    loginButton: Layout.color.coral,
    loginInputPlaceholderTextColor: Layout.color.sky,
    loginInputBackgroundColor: Layout.color.white,
    loginInputOpacity: 0.8,
    linkColor: Layout.color.beach,
    loginLinkColor: Layout.color.white,
    loginTextAreaFont: fontBold,
    formErrorColor: Layout.color.coral,
    chatBubbleMyBackgroundColor: Layout.color.sapphire,
    chatBubbleMyTextColor: Layout.color.white,
    chatBubbleMyDateTextColor: Layout.color.sky,
    chatBubbleOtherBackgroundColor: Layout.color.white,
    chatBubbleOtherTextColor: Layout.color.twilight,
    chatBubbleOtherDateTextColor: Layout.color.lightGray,
    chatButtonColor: Layout.color.white,
    extendedNotificationDisableDurations: false,
    leaveContactRequest: false,
    videoChatTextColor: Layout.color.white,

    headerLogo2020: assets.textOnlyLogo,
    textColor2020: Layout.color.semiBlack,
    logoStyle2020: { tintColor: Layout.color.white },
    containerColor2020: Layout.color.twilight,
    containerPressColor2020: Layout.color.twilightLight,
    panelColor2020: Layout.color.white,
    contentBoxColor2020: Layout.color.white,
    contentBoxBorderColor2020: Layout2020.color.gray,
    contentBoxBorderColorLight2020: Layout2020.color.semiGray,
    scrollListColor2020: Layout2020.color.lightGray,
    secondaryButton2020: Layout2020.color.midGray,
    headerLogoWidth2020: 0.2,

    dotIndicator: Layout.color.lightGray,
    titleBottomBorder: Layout.color.gray,
    endCallButton: Layout.color.coral,
    accentGuideColor: Layout.color.coral,
    defaultGuideColor: Layout.color.twilight,
    safeAreaColor: Layout.color.black,

    buttonUnderlayColor: Layout.color.white,
    shadowColor: Layout.color.shadowColor,

    luonaMainBrightColor: Layout.color.luonaMainBrightColor,
    luonaMainBrightOpacity: Layout.color.luonaMainBrightOpacity,
    luonaModalOverlay: Layout.color.luonaModalOverlay,
    luonaMainLightColor: Layout.color.luonaMainLightColor,
    luonaGrayTextColor: Layout.color.luonaGrayTextColor,
    luonaSuccessColor: Layout.color.luonaSuccessColor,
    luonaBorderColor: Layout.color.luonaBorderColor
  };

  if (
    contractPartnerId === Ids.contractPartners.monetra ||
    brand === 'monetra'
  ) {
    colors = {
      brand: 'monetra',
      businessType: businessTypeName,
      partner: contractPartnerName,
      hideRealSubscriberName: false,
      showPhoneNumber: true,
      autoSelectUILanguage: false,
      showInvoiceRef: true,
      feedbackSliders: false,
      noLanguageSelection: false,
      showMessageIfNoLanguageSelected: true,
      showMessageIfNoInterpreters: false,
      hideFreeTextFeedback: true,
      showKeepDisplayOn: true,
      phoneNumberUsername: true,
      statusBarStyle: 'dark-content',
      logo: assets.monetra_logo,
      pickerTextColor: Layout.color.black,
      pickerSelectedTextColor: blitzRed,
      popupTextColor: Layout.color.black,
      notificationTextColor: Layout.color.black,
      notificationBoldTextColor: blitzRed,
      buttonTextColor: Layout.color.black,
      buttonColor: blitzYellow,
      buttonDisabledColor: Layout.color.gray,
      buttonDisabledTextColor: Layout.color.lightGray,
      lastButtonColor: blitzRed,
      lastButtonTextColor: Layout.color.black,
      buttonFont: blitzFontBold,
      textFont: blitzFontNormal,
      fontLuona: fontLuona,
      titleFont: blitzFontBold,
      infoFont: blitzFontMedium,
      backgroundColor: Layout.color.white,
      textColor: Layout.color.black,
      logoStyle: {},
      logoWidth: 0.5,
      poweredByLogoStyle: { tintColor: Layout.color.white },
      loginLogoStyle: { opacity: 0.8 },
      logoPadding: 10,
      logoBottomMargin: 20,
      menuColor: blitzDarkGrey,
      containerColor: blitzGrey,
      selectedColor: 'rgba(0, 0, 0, 0.2)',
      selectedTextColor: 'rgba(255, 255, 255, 0.5)',
      textAreaBackground: blitzGrey,
      textAreaBorderColor: blitzDarkGrey,
      textAreaTextColor: Layout.color.black,
      textInputTextColor: Layout.color.black,
      textInputBackgroundColor: Layout.color.white,
      textAreaFont: blitzFontNormal,
      textInputFont: blitzFontBold,
      placeholderTextColor: blitzDarkGrey,
      loginInputPlaceholderTextColor: blitzDarkGrey,
      stars: Layout.color.black,
      showContinueButton: true,
      contactMeNow: true,
      poweredByLogo: assets.poweredByLogo,
      error: blitzYellow,
      warn: blitzYellow,
      success: blitzYellow,
      successTextColor: Layout.color.black,
      acceptColor: blitzYellow,
      acceptTextColor: Layout.color.black,
      cancelColor: blitzRed,
      cancelTextColor: Layout.color.black,
      errorColor: blitzRed,
      menuItemCountColor: blitzRed,
      background_login: assets.background_login,
      video: assets.video,
      loginButton: blitzYellow,
      loginInputBackgroundColor: '#ffffff',
      loginInputOpacity: 0.8,
      linkColor: Layout.color.white,
      loginLinkColor: Layout.color.white,
      loginTextAreaFont: blitzFontBold,
      formErrorColor: blitzRed,
      chatBubbleMyBackgroundColor: blitzYellow,
      chatBubbleMyTextColor: Layout.color.white,
      chatBubbleMyDateTextColor: Layout.color.white,
      chatBubbleOtherBackgroundColor: Layout.color.white,
      chatBubbleOtherTextColor: blitzDarkGrey,
      chatBubbleOtherDateTextColor: blitzGrey,
      chatButtonColor: Layout.color.white,
      extendedNotificationDisableDurations: false,
      leaveContactRequest: false,
      videoChatTextColor: Layout.color.white,

      headerLogo2020: assets.monetra_logo,
      textColor2020: Layout.color.semiBlack,
      logoStyle2020: { tintColor: Layout.color.white },
      containerColor2020: blitzRed,
      containerPressColor2020: blitzLightRed,
      panelColor2020: Layout.color.white,
      contentBoxColor2020: Layout.color.white,
      contentBoxBorderColor2020: Layout2020.color.gray,
      contentBoxBorderColorLight2020: Layout2020.color.semiGray,
      scrollListColor2020: Layout2020.color.lightGray,
      secondaryButton2020: Layout2020.color.midGray,
      headerLogoWidth2020: 0.2,

      dotIndicator: Layout.color.lightGray,
      titleBottomBorder: Layout.color.gray,
      endCallButton: Layout.color.coral,
      safeAreaColor: Layout.color.black,

      buttonUnderlayColor: Layout.color.white,
    };
  }

  // Hero Brand Configuration
  if (contractPartnerId === Ids.contractPartners.hero || isHeroBrandEnabled()) {
    colors = {
      brand: 'hero',
      businessType: businessTypeName,
      partner: contractPartnerName,
      // Direct Hero brand color access (like Tulka's twilight, beach, etc.)
      heroPurple: LayoutHero.color.heroPurple,
      heroBeige: LayoutHero.color.heroBeige,
      heroDarkBrown: LayoutHero.color.heroDarkBrown,
      heroBlue: LayoutHero.color.heroBlue,
      heroGreen: LayoutHero.color.heroGreen,
      heroCoral: LayoutHero.color.heroCoral,
      heroAccentDark: LayoutHero.color.heroAccentDark,
      heroPurple80: LayoutHero.color.heroPurple80,
      // Map Tulka color names to Hero equivalents for compatibility
      twilight: LayoutHero.color.heroDarkBrown, // Text color
      beach: LayoutHero.color.heroGreen,
      coral: LayoutHero.color.heroCoral,
      // Hero brand color variants with opacity (for borders, placeholders, hover states)
      borderColorLight: LayoutHero.color.heroDarkBrownBorderLight,
      borderColor: LayoutHero.color.heroDarkBrownBorder,
      borderColorMedium: LayoutHero.color.heroDarkBrownBorderMedium,
      placeholderColor: LayoutHero.color.heroDarkBrownPlaceholder,
      secondaryColor: LayoutHero.color.heroDarkBrownSecondary,
      hoverColor: LayoutHero.color.heroDarkBrownHover,
      beigeBackground: LayoutHero.color.heroBeigeBackground,
      showPhoneNumber: true,
      hideRealSubscriberName: false,
      autoSelectUILanguage: false,
      showInvoiceRef: true,
      feedbackSliders: false,
      showMessageIfNoLanguageSelected: true,
      showMessageIfNoInterpreters: false,
      hideFreeTextFeedback: true,
      noLanguageSelection: false,
      showKeepDisplayOn: true,
      phoneNumberUsername: true,
      statusBarStyle: 'light-content',
      logo: assets.hero_logo,
      pickerTextColor: LayoutHero.color.heroPurple,
      pickerSelectedTextColor: LayoutHero.color.heroPurple,
      popupTextColor: LayoutHero.color.heroPurple,
      notificationTextColor: LayoutHero.color.semiBlack,
      notificationBoldTextColor: LayoutHero.color.heroPurple,
      buttonColor: LayoutHero.color.heroPurple,
      buttonTextColor: LayoutHero.color.white,
      buttonDisabledColor: LayoutHero.color.gray,
      buttonDisabledTextColor: LayoutHero.color.lightGray,
      lastButtonColor: LayoutHero.color.heroBeige,
      lastButtonTextColor: LayoutHero.color.heroPurple,
      textFont: heroFontNormal,
      fontLuona: fontLuona,
      buttonFont: heroFontBold,
      primaryButtonFont2020: heroFontMedium,
      secondaryButtonFont2020: heroFontNormal,
      titleFont: heroFontBold,
      infoFont: heroFontMedium,
      backgroundColor: LayoutHero.color.white,
      textColor: LayoutHero.color.white,
      durationColor: LayoutHero.color.heroGreen,
      openRequestsColor: 'transparent',
      logoStyle: { tintColor: LayoutHero.color.white },
      loginLogoStyle: { opacity: 1 },
      logoWidth: 0.33,
      poweredByLogoStyle: { height: 0 },
      logoPadding: 0,
      logoBottomMargin: 20,
      menuColor: LayoutHero.color.white,
      containerColor: LayoutHero.color.heroPurple,
      selectedColor: 'rgba(139, 28, 147, 0.2)', // Purple with opacity
      selectedTextColor: 'rgba(255, 255, 255, 0.5)',
      placeholderTextColor: LayoutHero.color.heroBeige,
      textAreaBackground: LayoutHero.color.heroPurple,
      textAreaBorderColor: LayoutHero.color.white,
      textAreaTextColor: LayoutHero.color.white,
      textInputTextColor: LayoutHero.color.heroPurple,
      textInputBackgroundColor: LayoutHero.color.heroBeige,
      textAreaFont: heroFontNormal,
      textInputFont: heroFontBold,

      backgroundColorAi: 'rgba(226, 219, 200, 0.5)', // Beige with opacity
      webDarkBlue: LayoutHero.color.heroDarkBrown,
      tulkaMainColor: LayoutHero.color.heroPurple,
      iconAccentColor: LayoutHero.color.heroPurple,
      webBackground: '#F6F9FC',
      webGray: '#75706f',
      webMediumGray: '#929292',
      webOverlay: 'rgba(139, 28, 147, 0.9)', // Purple overlay
      webLightGray: '#F5F8FB',
      webSuccessColor: LayoutHero.color.heroGreen,
      webDefaultInputBorderColor: LayoutHero.color.heroBeige,
      webTextColor: LayoutHero.color.white,
      webMyTulkaGrayColor: '#f6f6f8',
      webMyTulkaErrorBackground: '#feebeb',
      webMyTulkaErrorText: LayoutHero.color.heroCoral,
      webDeviderColor: LayoutHero.color.heroBeige,

      feedbackGrayColor: LayoutHero.color.semiGray,
      feedbackBgColor: LayoutHero.color.heroPurple,
      feedbackSwitchColor: LayoutHero.color.heroPurple,

      popupTextInputBorderColor: LayoutHero.color.white,
      popupTextInputTextColor: LayoutHero.color.semiBlack,
      popupTextInputBackgroundColor: LayoutHero.color.white,
      popupPlaceholderTextColor: LayoutHero.color.lightGray,
      popupTextInputFont: heroFontNormal,

      stars: LayoutHero.color.white,
      showContinueButton: true,
      contactMeNow: true,
      poweredByLogo: assets.poweredByLogo, // TODO: Update with Hero powered-by logo if needed
      error: LayoutHero.color.heroCoral,
      warn: LayoutHero.color.heroBlue,
      success: LayoutHero.color.heroGreen,
      successTextColor: LayoutHero.color.white,
      acceptColor: LayoutHero.color.heroGreen,
      acceptTextColor: LayoutHero.color.white,
      cancelColor: LayoutHero.color.heroCoral,
      cancelTextColor: LayoutHero.color.white,
      errorColor: LayoutHero.color.heroCoral,
      menuItemCountColor: blitzRed,
      background_login: assets.background_login,
      video: assets.video,
      loginButton: LayoutHero.color.heroPurple,
      loginInputPlaceholderTextColor: LayoutHero.color.heroBeige,
      loginInputBackgroundColor: LayoutHero.color.white,
      loginInputOpacity: 0.9,
      linkColor: LayoutHero.color.heroGreen,
      loginLinkColor: LayoutHero.color.white,
      loginTextAreaFont: heroFontBold,
      formErrorColor: LayoutHero.color.heroCoral,
      chatBubbleMyBackgroundColor: LayoutHero.color.heroPurple,
      chatBubbleMyTextColor: LayoutHero.color.white,
      chatBubbleMyDateTextColor: LayoutHero.color.heroBeige,
      chatBubbleOtherBackgroundColor: LayoutHero.color.white,
      chatBubbleOtherTextColor: LayoutHero.color.heroPurple,
      chatBubbleOtherDateTextColor: LayoutHero.color.lightGray,
      chatButtonColor: LayoutHero.color.white,
      extendedNotificationDisableDurations: false,
      leaveContactRequest: false,
      videoChatTextColor: LayoutHero.color.white,

      headerLogo2020: assets.hero_logo_white,
      textColor2020: LayoutHero.color.semiBlack,
      logoStyle2020: { tintColor: LayoutHero.color.white },
      containerColor2020: LayoutHero.color.heroDarkBrown,
      containerPressColor2020: LayoutHero.color.heroDarkBrown,
      panelColor2020: LayoutHero.color.white,
      contentBoxColor2020: LayoutHero.color.white,
      contentBoxBorderColor2020: Layout2020.color.gray,
      contentBoxBorderColorLight2020: Layout2020.color.semiGray,
      scrollListColor2020: Layout2020.color.lightGray,
      secondaryButton2020: Layout2020.color.midGray,
      headerLogoWidth2020: 0.2,

      dotIndicator: LayoutHero.color.lightGray,
      titleBottomBorder: LayoutHero.color.gray,
      endCallButton: LayoutHero.color.heroCoral,
      accentGuideColor: LayoutHero.color.heroCoral,
      defaultGuideColor: LayoutHero.color.heroPurple,
      safeAreaColor: LayoutHero.color.black,

      buttonUnderlayColor: LayoutHero.color.white,
      shadowColor: LayoutHero.color.shadowColor,

      // Hero specific properties
      heroTagline: 'Gjør en ny framtid mulig',
      heroTaglineEn: 'Enabling a new future',
      heroTaglineDe: 'Eine neue Zukunft möglich machen',
    };
  }

  return colors;
}
